import { Callout, Collapse, HTMLTable, Tag } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import i18n from "../../../../i18n";

import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";
import PieChart from "../../../Charts/PieChart";
import { SensorPreview } from "../Sensors/Sensors";

export default function Lanes(props) {
  const [lanes, setLanes] = useState([]);
  const [selected, select] = useState(undefined);
  const [laneConfig, setLaneConfig] = useState({});
  const [laneSensors, setLaneSensors] = useState([]);
  const [devices, setDevices] = useState({});
  const [devices_lookup, setDevices_lookup] = useState({});
  const [performances, setPerformances] = useState({});

  useEffect(() => {
    authenticatedGetFetch("/ow/dc/lanes?srv=" + props.srv, (lanes) =>
      setLanes(lanes)
    );
    authenticatedGetFetch("/ow/dc/lanes/perf?srv=" + props.srv, (lanes) =>
      setLanes(lanes)
    );
    authenticatedGetFetch(
      "/devices?srvfilter=" + props.srv,
      (response) => {
        setDevices(response);
        const lookup = {};
        const devices = {};
        for (const device of response) {
          lookup[device.id] = device.name || device.id;
          devices[device.id] = device;
        }
        setDevices_lookup(lookup);
        setDevices(devices);
      }
    );
  }, [props.srv]);

  useEffect(() => {
    if (selected) {
      authenticatedGetFetch(
        "/ow/dc/lane/" + selected?.id + "/config?srv=" + props.srv,
        (config) => setLaneConfig(config)
      );
      authenticatedGetFetch(
        "/ow/dc/lane/" + selected?.id + "/sensors?srv=" + props.srv,
        (sensors) => setLaneSensors(sensors)
      );
      authenticatedGetFetch(
        "/ow/dc/lane/" + selected?.id + "/perf?srv=" + props.srv,
        (performances) => setPerformances(performances)
      );
    }
  }, [selected, props.srv]);

  return (
    <Callout icon="horizontal-distribution" title={<Trans>lanes</Trans>}>
      {lanes.map((s) => (
        <div>
          <Callout
            title={`${devices_lookup[s.id]} (${i18n.t(devices[s.id]?.type)})`}
            onClick={() => select(selected?.id === s.id ? undefined : s)}
            style={{ cursor: "pointer" }}
            intent={selected?.id === s.id ? "primary" : "normal"}
            icon={selected?.id === s.id ? "chevron-up" : "chevron-down"}
          >
            <Tag>
              {s.transactions} <Trans>detections</Trans>
            </Tag>
          </Callout>
          <Collapse isOpen={selected?.id === s.id}>
            <Callout title={<Trans>sensors</Trans>}>
              {(laneSensors || []).map((s) => (
                <SensorPreview {...s} />
              ))}
            </Callout>
            {performances?.detections_per_transaction && (
              <Callout>
                <div className="flexbox-center">
                  <PieChart
                    labels={performances.detections_per_transaction.map(
                      (c) => c.detection_count
                    )}
                    data={performances.detections_per_transaction.map(
                      (c) => c.count
                    )}
                    title={i18n.t("detections per transaction")}
                  />
                  <div>
                    <HTMLTable>
                      <thead>
                        <tr>
                          <th>
                            <Trans>camera detection</Trans>
                          </th>
                          <th>
                            <Trans>Nombre de passage</Trans>
                          </th>
                          <th>{/* % */}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {performances.detections_per_transaction.map((c) => {
                          const sum =
                            performances.detections_per_transaction.reduce(
                              (accumulator, current) =>
                                accumulator + parseInt(current.count),
                              0
                            );
                          return (
                            <tr>
                              <td>
                                <Tag>
                                  {c.detection_count}{" "}
                                  {c.detection_count > 1 ? (
                                    <Trans>images</Trans>
                                  ) : (
                                    <Trans>image</Trans>
                                  )}
                                </Tag>
                              </td>
                              <td>{c.count}</td>
                              {sum > 0 ? (
                                <td>{((c.count / sum) * 100).toFixed(2)}%</td>
                              ) : (
                                <td></td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </HTMLTable>
                  </div>
                </div>
              </Callout>
            )}

            {devices[s.id]?.type === "BE" &&
              performances?.nbMatchings_entry && (
                <Callout>
                  <div className="flexbox-center">
                    <PieChart
                      labels={performances.nbMatchings_entry.map((c) =>
                        i18n.t("tolerance_level_" + c.method)
                      )}
                      data={performances.nbMatchings_entry.map((c) => c.count)}
                      title={i18n.t("matchings")}
                    />
                    <div>
                      <HTMLTable>
                        <thead>
                          <tr>
                            <th>
                              <Trans>matching method</Trans>
                            </th>
                            <th>
                              <Trans>Nombre de correspondance</Trans>
                            </th>
                            <th>{/* % */}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {performances.nbMatchings_entry.map((c) => {
                            const sum = performances.nbMatchings_entry.reduce(
                              (accumulator, current) =>
                                accumulator + parseInt(current.count),
                              0
                            );
                            let intent = "";
                            switch (c.method) {
                              case 0:
                                intent = "success";
                                break;
                              case null:
                                intent = "danger";
                                break;
                              default:
                                intent = "warning";
                                break;
                            }
                            return (
                              <tr>
                                <td>
                                  <Tag intent={intent}>
                                    <Trans>
                                      {"tolerance_level_" + c.method}
                                    </Trans>
                                  </Tag>
                                </td>
                                <td>{c.count}</td>
                                {sum > 0 ? (
                                  <td>{((c.count / sum) * 100).toFixed(2)}%</td>
                                ) : (
                                  <td></td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </HTMLTable>
                    </div>
                  </div>
                </Callout>
              )}

            {devices[s.id]?.type !== "BE" && performances?.nbMatchings_exit && (
              <Callout>
                <div className="flexbox-center">
                  <PieChart
                    labels={performances.nbMatchings_exit.map((c) =>
                      i18n.t("tolerance_level_" + c.method)
                    )}
                    data={performances.nbMatchings_exit.map((c) => c.count)}
                    title={i18n.t("matchings")}
                  />
                  <div>
                    <HTMLTable>
                      <thead>
                        <tr>
                          <th>
                            <Trans>matching method</Trans>
                          </th>
                          <th>
                            <Trans>Nombre de correspondance</Trans>
                          </th>
                          <th>{/* % */}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {performances.nbMatchings_exit.map((c) => {
                          const sum = performances.nbMatchings_exit.reduce(
                            (accumulator, current) =>
                              accumulator + parseInt(current.count),
                            0
                          );
                          let intent = "";
                          switch (c.method) {
                            case 0:
                              intent = "success";
                              break;
                            case null:
                              intent = "danger";
                              break;
                            default:
                              intent = "warning";
                              break;
                          }
                          return (
                            <tr>
                              <td>
                                <Tag intent={intent}>
                                  <Trans>{"tolerance_level_" + c.method}</Trans>
                                </Tag>
                              </td>
                              <td>{c.count}</td>
                              {sum > 0 ? (
                                <td>{((c.count / sum) * 100).toFixed(2)}%</td>
                              ) : (
                                <td></td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </HTMLTable>
                  </div>
                </div>
              </Callout>
            )}
          </Collapse>
          <br />
        </div>
      ))}
    </Callout>
  );
}
